const styles = {
  snackbar: { width: '100%', bottom: 51, zIndex: 1 },
  snackbarContent: { width: '100%' },
  snackbarTitle: {
    frontWeight: 500,
    fontSize: 16,
    lineHeight: 1.17,
  },
  snackbarTextContent: {
    fontSize: 12,
    lineHeight: 1.33,
  },
}

export default styles
